module.exports = "/assets/08438cd228666e19983c4fabe6396c5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/7H.png
// module id = 1111
// module chunks = 0